import React, { useCallback, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { CardActionArea, CardContent, Typography } from '@mui/material';
import PayStateModal from 'routes/HumanResourcesModule/PayState/PayStateHome/components/PayStateModal/PayStateModal';
import { useCreatePayState } from 'routes/HumanResourcesModule/PayState/helpers/hooks/payState';
import { PayStateCreateFieldT } from 'routes/HumanResourcesModule/PayState/helpers/types';
import StyCard from 'routes/HumanResourcesModule/components/ui/StyCard';

const StyCardContent = styled(CardContent)(({ theme }) => ({
    display: 'flex',
    backgroundColor: 'rgba(65, 99, 165, 0.15)',
    alignItems: 'center',
    padding: theme.spacing(2),
    height: '100%',
}));

function AddPayStateButton({
    currentExercice,
}: {
    currentExercice: number;
}): React.ReactElement {
    const { t } = useTranslation();
    const [showPayStateModal, setShowPayStateModal] = useState(false);
    const createPayStateMutation = useCreatePayState();
    const {
        isPending: isPayStateMutationLoading,
        isError: isPayStateMutationError,
    } = createPayStateMutation;

    const onSave = ({
        exercice,
        title,
        orgChartHrsSoftwareIds,
        etablissementSoftwareIds,
        isEtablissementsFilterActive,
        payBudgetSoftwareIds,
        isPayBudgetFilterActive,
    }: PayStateCreateFieldT) => {
        createPayStateMutation.mutate({
            exercice,
            title,
            orgChartHrsSoftwareIds,
            etablissementSoftwareIds,
            isEtablissementsFilterActive,
            payBudgetSoftwareIds,
            isPayBudgetFilterActive,
        });
    };

    const closeModal = useCallback(
        () => setShowPayStateModal(false),
        [setShowPayStateModal],
    );
    const openModal = useCallback(
        () => setShowPayStateModal(true),
        [setShowPayStateModal],
    );

    return (
        <StyCard sx={{ height: '12rem' }}>
            <CardActionArea sx={{ height: '100%' }} onClick={openModal}>
                <StyCardContent>
                    <AddCircleIcon
                        fontSize="large"
                        color="primary"
                        sx={{ ml: '1rem' }}
                    />
                    <Typography
                        sx={{ fontWeight: 'bold', ml: '1rem' }}
                        color="primary"
                    >
                        {t('humanResources.addPayState')}
                    </Typography>
                </StyCardContent>
            </CardActionArea>
            {showPayStateModal && (
                <PayStateModal
                    onSave={onSave}
                    show={showPayStateModal}
                    onClose={closeModal}
                    isLoading={isPayStateMutationLoading}
                    isError={isPayStateMutationError}
                    currentExercice={currentExercice}
                />
            )}
        </StyCard>
    );
}

export default AddPayStateButton;
